import { lazy } from "react";
import MainLayout from "layout/MainLayout";
import Loadable from "components/Loadable";
import AuthGuard from "utils/route-guard/AuthGuard";
import FeedbackRoutes from "pages/Feedback/utils/route";
import PreventiveMaintenanceRoutes from "pages/Preventive-Maintenance/utils/route";
import ControlOfDocumentRoute from "pages/Control-Of-Document/utils/route";
import CORRoutes from "pages/Control-Of-Records/utils/route";
import InternalCommunicationRoute from "pages/Internal-Communication/utils/route";
import ServicingRoutes from "pages/CustomerService/utils/route";
import CPRoutes from "pages/CustomerProperty/utils/route";
import CONCPRoute from "pages/Control-of-Non-Conforming-Product/utils/route";
import MAMEquipmentRoutes from "pages/Mam-of-equipments/utils/route";
import MAMRoutes from "pages/Mam-Of-Products/utils/route";
import WERoutes from "pages/Work-Environment/utils/route";
import CRPDRoutes from "pages/CRPD/utils/route";
import finishedProductRegisterRoute from "pages/finishedProductRegister/utils/route";
import changeNoteRoute from "pages/Change-Note/utils/route";
import productDescriptionRoute from "pages/Product-Description/utils/route";
import dynamicDocumentRoute from "pages/DynamicDocument/utils/route";
import qualityManualRoutes from "pages/standards/QualityManual/utils/route";
import procedureRoutes from "pages/standards/Procedure/utils/route";
import FormatStructureRoute from "pages/standards/Format/utils/route";
import RecordsRoute from "pages/Records/utils/route";
import RecordRoute from "pages/Record/utils/route";
import newPurchaseRoute from "pages/NewPurchase/utils/newPurchaseRoute";
import InstallationRoutes from "pages/Installation/utils/InstallationRoutes";
import PVRoutes from "pages/Process-Validation/utils/routes";
import CWRBRoutes from "pages/Communication-with-regulatory-body/utils/routes";
import CCRoutes from "pages/CustomerComplaint/utils/routes";
import ARRoutes from "pages/Advisory-Recall/Utils/routes";
import NewMRMRoutes from "pages/NewManagementReviewMeeting/utils/route";
import FormatRoute from "pages/Format/utils/route";
import ProdRoutes from "pages/ProductionNew/utils/ProdRoutes";
import CAPARoutes from "pages/CAPA/utils/routes";
import PermissionRoute from "pages/Permission/utils/route";
import NewIQARoutes from "pages/NewIQA/Utils/routes";
import ArchiveRoute from "pages/Archive/utils/route";
import QORoutes from "pages/Quality-Objective/utils/route";
import AuditRoutes from "pages/Audit-Trail/utils/routes";
import catNewRoutes from "pages/CATDynamic/utils/catNewRoutes";

const Calendar = Loadable(lazy(() => import("components/Calendar")));
const Dashboard = Loadable(lazy(() => import("pages/Dashboard/Dashboard")));
const RenderTest = Loadable(
  lazy(() => import("components/CustomizeDynamicTable/RenderTest"))
);
const DocumentCustomization = Loadable(
  lazy(() =>
    import(
      "pages/Document-Customization/NewDocumentCustomization/DocumentCustomization"
    )
  )
);
const Notification = Loadable(
  lazy(() => import("pages/Notification/Notification"))
);
const AssignedDocs = Loadable(lazy(() => import("pages/Users/AssignDocs")));
const Question = Loadable(
  lazy(() => import("pages/StandardQuestion/Question"))
);
const UserLists = Loadable(lazy(() => import("pages/Users/UserLists")));
const MasterTable = Loadable(
  lazy(() => import("pages/MasterTable/MasterTable"))
);
const Profile = Loadable(lazy(() => import("pages/ProfilePage/Profile")));

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    { path: "dashboard", element: <Dashboard /> },
    { path: "test-new-dynamic-table", element: <RenderTest /> },
    { path: "document-customization", element: <DocumentCustomization /> },
    {
      path: "standards",
      children: [{ path: "docs", element: <AssignedDocs /> }],
    },
    {
      path: "standards-question",
      children: [{ path: "question", element: <Question /> }],
    },
    { path: "users", element: <UserLists /> },
    { path: "profile", element: <Profile /> },
    { path: "master-table", element: <MasterTable /> },
    { path: "calendar", element: <Calendar /> },
    { path: "notification", element: <Notification /> },
    ...FeedbackRoutes,
    ...PreventiveMaintenanceRoutes,
    ...ControlOfDocumentRoute,
    ...CORRoutes,
    ...InternalCommunicationRoute,
    ...ServicingRoutes,
    ...CPRoutes,
    ...CONCPRoute,
    ...MAMEquipmentRoutes,
    ...MAMRoutes,
    ...WERoutes,
    ...CRPDRoutes,
    ...finishedProductRegisterRoute,
    ...changeNoteRoute,
    ...productDescriptionRoute,
    ...dynamicDocumentRoute,
    ...qualityManualRoutes,
    ...procedureRoutes,
    ...FormatStructureRoute,
    ...RecordsRoute,
    ...RecordRoute,
    ...newPurchaseRoute,
    ...InstallationRoutes,
    ...PVRoutes,
    ...CWRBRoutes,
    ...CCRoutes,
    ...ARRoutes,
    ...NewMRMRoutes,
    ...FormatRoute,
    ...ProdRoutes,
    ...CAPARoutes,
    ...PermissionRoute,
    ...NewIQARoutes,
    ...ArchiveRoute,
    ...QORoutes,
    ...AuditRoutes,
    ...catNewRoutes,
  ],
};

export default MainRoutes;
